import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { BranchService } from 'src/app/shared/API-Service/services/branch.service';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';
import { CountryService } from 'src/app/shared/API-Service/services/country.service';

@Component({
  selector: 'app-insert-governorate',
  templateUrl: './insert-governorate.component.html',
  styleUrls: ['./insert-governorate.component.css']
})
export class InsertGovernorateComponent implements OnInit {
  recordtoupdate: any;
  countries:object [];
  governorateForm : FormGroup;
update:boolean = false;
button:boolean = false;
  constructor(private _GovernorateService:GovernorateService,private _Router:Router,
    private _FormBuilder:FormBuilder,
    private _CountryService:CountryService) { }

  ngOnInit(): void {
    this.initiate();
    this.getcountries();
    this.checkEdit();
  }
getcountries(){
  this._CountryService.GetCountry().subscribe((res) => {
    this.countries = res.data;
  })
}
  initiate(){
    this.governorateForm = this._FormBuilder.group({
      title: ['', Validators.required],
     countryId:['', Validators.required]
    });
  }
  checkEdit() {
    this._GovernorateService.Data.subscribe((res) => {
      if (res != null) {
        this.governorateForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
         countryId:[res.countryId, Validators.required]
        });
        this.update = true;
        this.recordtoupdate = res ;
        console.log(this.recordtoupdate);
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  get fc() {
    return this.governorateForm.controls;
  }
    onSubmit(){
      this.button = true;
    if(this.update == false && this.governorateForm.status == "VALID"){
      this._GovernorateService.CreateGovernorate(this.governorateForm.value).subscribe((res) => {
        Swal.fire({
          icon: "success",
          title: "تم الحفظ بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });
        this.governorateForm.reset();
        this._Router.navigate(['/content/admin/ViewGovernorate']);
      },(err) => {
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text:err.message    
        }) 
        this.button = false ;
      }, () => {
        console.log('completed ');
      })
    } else if(this.governorateForm.status == "VALID"){
      this.governorateForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
      this._GovernorateService.UpdateGovernorate(this.governorateForm.value).subscribe((res) => {
        Swal.fire({
          icon: "success",
          title: "تم التعديل بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });
        this.governorateForm.reset();
        this._Router.navigate(['/content/admin/ViewGovernorate']);
      },(err) => {
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text:err.message    
        }) 
      }, () => {
        console.log('completed ');
      })
    }else {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:"بالرجاء التأكد من ملئ جميع الحقول"   
      })
      this.governorateForm.markAllAsTouched();
      this.button = false;
    }
    }
    ngOnDestroy(){
      this._GovernorateService.Data.next(null);
      }

}
